"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _routeMatch = require("../../utils/routeMatch");
var _types = require("./types");
/**
 * set attendeeId to session storage
 * allows us to persist the attendeeId across refreshes
 * @param attendeeId
 * @returns {(function(*, *, *): void)|*}
 */
function setMeetingDirectorValue(attendeeId) {
  return (0, _routeMatch.withCurrentParams)(function (dispatch, _ref) {
    var broadcastId = _ref.broadcastId;
    sessionStorage.setItem("CURRENT_DIRECTOR_ATTENDEE-".concat(broadcastId), attendeeId);
    var action = {
      type: _types.BROADCAST_SET_DIRECTOR_MEETING_VALUE,
      payload: {}
    };
    dispatch(action);
    return {};
  });
}
var _default = exports["default"] = setMeetingDirectorValue;